import { baseInstance } from "src/api";
import { GetEventPayload, PaginationData } from "src/types/api";

export const getEvents = async (payload: GetEventPayload) => {
  try {
    return await baseInstance.get(
      `events?page=${payload.page}&page_size=${payload.size}${
        payload.filter ? `&filter=${payload.filter}` : ""
      }${payload.search ? `&search=${payload.search}` : ""}`
    );
  } catch (err: any) {
    return err;
  }
};

export const getEvent = async (id: string) => {
  try {
    return await baseInstance.get(`events/${id}`);
  } catch (err: any) {
    return err;
  }
};

export const getUserEvents = async (payload: PaginationData) => {
  try {
    return await baseInstance.get(
      `events/short?page=${payload.page}&page_size=${payload.size}`
    );
  } catch (err: any) {
    return err;
  }
};

export const createEvent = async (payload: FormData) => {
  try {
    return await baseInstance.post("events/", payload);
  } catch (err: any) {
    return err;
  }
};

export const removeFavorite = async (id: number) => {
  try {
    return await baseInstance.delete(`events/favorite/${id}/`);
  } catch (err: any) {
    return err;
  }
};

export const saveFavorite = async (id: number) => {
  try {
    return await baseInstance.post(`events/favorite/${id}/`);
  } catch (err: any) {
    return err;
  }
};

export const getFavoriteEvents = async (payload: PaginationData) => {
  try {
    return await baseInstance.get(
      `events/favorite?page=${payload.page}&page_size=${payload.size}`
    );
  } catch (err: any) {
    return err;
  }
};

export const getChartsEvents = async (id: number) => {
  try {
    return await baseInstance.get(`/events/price-history/?event_id=${id}`);
  } catch (err: any) {
    return err;
  }
};
